<template>
    <div class="TheLogo">
        <div class="TheLogo__icon">
            <img src="static/images/icons/android-icon-144x144.png" class="TheLogo__image" />
        </div>
        <div class="TheLogo__title">
            {{appFirstWord}}<span class="TheLogo__color">{{appSecondWord}}</span>
        </div>
    </div>
</template>

<script>
    import constants from '../../store/constants';

    export default {
        name: 'TheLogo',
        computed: {
            appFirstWord: () => constants.appFirstWord,
            appSecondWord: () => constants.appSecondWord
        }
    };
</script>

<style>
    .TheLogo {
        display: flex;
        flex-direction: row;
    }

    .TheLogo__icon {
        height: 32px;
        width: 32px;
        margin-right: 4px;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    .TheLogo__image {
        height: 32px;
        width: 32px;
    }

    .TheLogo__title {
        -webkit-font-smoothing: antialiased;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: 32px;
        color: rgba(255,255,255,0.7);
        margin-right: 10px;
        font-family: voltaire;
        font-size: 12px;
        font-weight: 400
    }

    .TheLogo__color {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// TheLogo.vue?b09056a2